// extracted by mini-css-extract-plugin
export default {"filtersCol":"daily-balance-history_filtersCol__olul8","form":"daily-balance-history_form__t19vV","formItem":"daily-balance-history_formItem__R7ft+"};